
import { Grid, IconButton, Typography } from '@material-ui/core'
import { CircleHelp } from 'lucide-react'
import { useStyles } from './style'

const MainHeader = ({
  children,
  title,
  description,
  showTutorial = false,
  onTutorialClick,
  tutorialIcon,
  tutorialText = 'Tutorial'
}) => {
  const classes = useStyles()

  const renderHeaderContent = () => {
    if (title || description || showTutorial) {
      return (
        <Grid container>
          {title && (
            <div className={classes.headerTitleBox}>
              <Typography variant='h5'>{title}</Typography>
              {showTutorial && (
                <div className={classes.headerTutorial}>
                  <IconButton onClick={onTutorialClick || (() => {})}>
                    {tutorialIcon || <CircleHelp size={20} />}
                    <span>{tutorialText}</span>
                  </IconButton>
                </div>
              )}
            </div>
          )}
          {description && (
            <div className={classes.headerDescription}>
              <span>{description}</span>
            </div>
          )}
        </Grid>
      )
    }
    return null
  }

  return (
    <div className={classes.contactsHeader}>
      {renderHeaderContent()}
      {children}
    </div>
  )
}
// MainHeader.propTypes = {
//   children: PropTypes.node,
//   title: PropTypes.node,
//   description: PropTypes.node,
//   showTutorial: PropTypes.bool,
//   onTutorialClick: PropTypes.func,
//   tutorialIcon: PropTypes.node,
//   tutorialText: PropTypes.string
// }
export default MainHeader
